/** True for an absolute http(s) URL of at most 2048 characters (the only kind a board ever stores or opens). */
export function isHttpUrl(s: string): boolean {
  if (typeof s !== 'string' || s.length > 2048) return false;
  try {
    const u = new URL(s);
    return (u.protocol === 'http:' || u.protocol === 'https:') && u.hostname !== '';
  } catch {
    return false;
  }
}
